import { createEnvelopeSource } from './create-envelope-source';

/**
 * New-users source (app accounts created) over the standardized envelope
 * (`GET /analytics/new-users`). This is the dedicated home for the
 * account-creation count that age-gating also surfaces as its `newUsers`
 * denominator and profile-creation as `registrations` (all three sourced from
 * the same backend new-users compute).
 *
 * No longer a `split` card. RPP registrations are their own source
 * (`new-users-rpp`): an app account created and an RPP registration filed are
 * different events on different tables, so the pair never summed and neither
 * nested in the other. A card that wants both composes two sources.
 */
export const newUsersSource = createEnvelopeSource({
    label: 'New users',
    endpoint: 'analytics/new-users',
    metrics: [{ id: 'newUsers', label: 'New users', type: 'scalar' }],
    forms: ['number'],
    regionGrain: 'province',
});
